export function getReaderNames(data) {
  return data && data
    .map((e) => e.acf.reader_profile_description_fullname)
    .filter((e) => e !== '')
    .filter((item, pos, self) => self.indexOf(item) === pos);
}
